import { render, staticRenderFns } from "./OrderNotesDetails.vue?vue&type=template&id=1af35efc&scoped=true"
import script from "./OrderNotesDetails.vue?vue&type=script&lang=ts"
export * from "./OrderNotesDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af35efc",
  null
  
)

export default component.exports